import { FormControl } from '@angular/forms';

export enum Severity {
  Default,
  Warning,
  Success,
  Base,
}

export interface FormField {
  label: string;
  name: string;
  type: 'text' | 'number' | 'email' | 'password';
  controller: FormControl;
  placeholder?: string;
}

export interface FilesToUpload {
  file: File;
  src: string;
}
